import { useTranslation } from "next-i18next";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Button from "../../Button";

interface StartNextProps {
  completed: number;
  nextQuestSlug: string;
}

function StartNext({ completed, nextQuestSlug }: StartNextProps) {
  const { t } = useTranslation("classroom");
  const router = useRouter();
  const [label, setlabel] = useState<string>(t("startClassroom"));

  const handleClick = () => {
    router.push({
      pathname: `/quests/${nextQuestSlug}`,
      query: { classroom: router.query.title },
    });
  };

  useEffect(() => {
    if (completed > 0) {
      setlabel(t("continueClassroom"));
    } else {
      setlabel(t("startClassroom"));
    }
  }, [completed]);

  return (
    <div className="w-full flex flex-col sm:flex-row md:flex-col lg:flex-row sm:items-center md:items-start lg:items-center gap-6 place-content-between">
      <div className="bodyText">{t("getStarted")}</div>
      <Button
        label={label}
        onClick={handleClick}
        svgIcon="Arrowright"
        className="sm:hidden md:flex lg:hidden"
        stretch
      />
      <Button
        label={label}
        onClick={handleClick}
        svgIcon="Arrowright"
        className="hidden sm:flex md:hidden lg:flex"
      />
    </div>
  );
}

export default StartNext;
